import { activeLoansReducer } from "@/pages/activeLoans/activeLoansSlice";
import errorNoticeSlice from "@/pages/error/errorNotice/errorNoticeSlice";
import legalConsentSlice from "@/pages/legalConsent/LegalConsentSlice";
import loanAppSlice from "@/pages/loanApp/loanAppSlice";
import { combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import { baseApi } from "../api/baseApi";
import { authMiddleware, errorLoggerMiddleware, fulfilledRequestLoggerMiddleware } from "../middlewares/index";
import { authPersistedReducer, logSliceReducer, transactionIdSliceReducer } from "../slices/index";

const reducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  //Slices
  activeLoansSlice: activeLoansReducer,
  loanAppSlice,
  transactionIdSlice: transactionIdSliceReducer,
  legalConsentSlice,
  errorNoticeSlice,
  logSlice: logSliceReducer,
  authSlice: authPersistedReducer,
});

type RootReducerState = ReturnType<typeof reducer>;

export const createStore = (preloadedState?: Partial<RootReducerState>) =>
  configureStore({
    reducer,
    devTools: import.meta.env.DEV,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .concat(authMiddleware as Middleware)
        .concat(errorLoggerMiddleware as Middleware)
        .concat(fulfilledRequestLoggerMiddleware as Middleware)
        .concat(baseApi.middleware),
  });
const store = createStore();

export type AppStore = typeof store;
export type AppDispatch = AppStore["dispatch"];
export type RootState = ReturnType<AppStore["getState"]>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;

export const persistor = persistStore(store);
